<template>
	<div class="container px-0">
		<div class="row">
			<div class="order-1 order-lg-0 col-lg-6 col-xl-5">
                <!--Initial Briefing Docs-->
                <div class="job-information-card">
                    <div class="job-information-card--header">
                        <h5 class="job-information-card--header-title">Induction Documents</h5>
                        <job-file-upload-button
                            v-if="has_full_job_access"
                            :upload_url="upload_initial_briefing_url"
                            color="positive"
                            @uploaded="addToInitialBriefingDocument($event)"
                        ></job-file-upload-button>
                    </div>
                    <div class="job-information-car--content">
                        <list-component
                            :no_padding="true"
                            :items="initial_briefing_documents_edit"
                            action_url_prop="url"
                            @optionClicked="processOption(initial_briefing_documents_edit, $event)"
                            no_results_message="Please add your first briefing document"
                            :options="has_full_job_access ? [{
                                    icon_src: '/svg/' + resource_group + '/bin.svg',
                                    icon_color: 'danger',
                                    label: 'delete',
                                    action_method: 'delete',
                                    action_url: delete_initial_briefing_url,
                                    action_resolve: 'emit_optionClicked',
                                    confirm_message: 'Are you sure you want to delete this file?'
                                }] : null"
                        ></list-component>
                    </div>
                </div>

                <!--Job Docs-->
                <div class="job-information-card">
                    <div class="job-information-card--header">
                        <h5 class="job-information-card--header-title">Project Documents</h5>
                        <job-file-upload-button
                            v-if="has_full_job_access"
                            :upload_url="upload_job_document_url"
                            color="positive"
                            @uploaded="addToJobDocuments($event)"
                        ></job-file-upload-button>
                    </div>
                    <div class="job-information-car--content">
                        <list-component
                            :no_padding="true"
                            :items="job_documents_edit"
                            action_url_prop="url"
                            @optionClicked="processOption(job_documents_edit, $event)"
                            no_results_message="Please add your first project document"
                            :options="has_full_job_access ? [{
                                icon_src: '/svg/' + resource_group + '/bin.svg',
                                icon_color: 'danger',
                                label: 'delete',
                                action_method: 'delete',
                                action_url: delete_job_document_url,
                                action_resolve: 'emit_optionClicked',
                                confirm_message: 'Are you sure you want to delete this file?'
                            }] : null"
                        ></list-component>
                    </div>
                </div>

                <!--Ram docs-->
                <div class="job-information-card">
                    <div class="job-information-card--header">
                        <h5 class="job-information-card--header-title">RAMS Documents</h5>
                        <job-file-upload-button
                            v-if="has_full_job_access"
                            :upload_url="upload_rams_document_url"
                            color="positive"
                            @uploaded="addToRamsDocuments($event)"
                        ></job-file-upload-button>
                    </div>
                    <div class="job-information-card--content">
                        <list-component
                            :no_padding="true"
                            :items="rams_documents_edit"
                            action_url_prop="url"
                            @optionClicked="processOption(rams_documents_edit, $event)"
                            no_results_message="No RAMS documents found"
                            :options="has_full_job_access ? [{
                                icon_src: '/svg/' + resource_group + '/bin.svg',
                                icon_color: 'danger',
                                label: 'delete',
                                action_method: 'delete',
                                action_url: delete_rams_document_url,
                                action_resolve: 'emit_optionClicked',
                                confirm_message: 'Are you sure you want to delete this file?'
                            }] : null"
                        ></list-component>
                    </div>
                </div>


                <!--Details-->
				<div class="job-information-card">
                    <div class="job-information-card--header">
                        <h5 class="job-information-card--header-title">Project details</h5>
                        <button
                            v-if="can_crud_jobs"
				            class="work-days-input--header-button btn btn-primary"
				            v-bind:disabled="saving"
				            v-on:click="editJobDate"
			            >
				            <loader class="loaders--small loaders--light" v-if="saving"></loader>
				            <span v-else>Save</span>
			            </button>
                    </div><br>

                    <div class="job-information-card--content">
                        <div class="job-information-card--content-group">
                            <h5 class="job-information-card--content-group-label">Job Name</h5>
                            <input type="text" v-model="job_edit.name" class="form-control job-information-card--content-group-input" v-bind:disabled="can_crud_jobs === false">
                        </div>
                        <div class="job-information-card--content-group">
                            <h5 class="job-information-card--content-group-label">Project Code</h5>
                            <input type="text" v-model="job_edit.project_code" class="form-control job-information-card--content-group-input" v-bind:disabled="can_crud_jobs === false">
                        </div>
                        <div class="job-information-card--content-group">
                            <h5 class="job-information-card--content-group-label">Start Date</h5>
                            <div class="job-information-card--content-group-input">
                                <input type="text" class="form-control w-25 mr-2" v-model="day_selected" v-bind:disabled="job.status !== 'ready'" >
                                <input type="text" class="form-control w-50" v-model="month_selected" v-bind:disabled="job.status !== 'ready'" >
                                <input type="text" class="form-control w-25 ml-2" v-model="year_selected" v-bind:disabled="job.status !== 'ready'" >
                            </div>
                        </div>
                        <div v-if="job.status === 'closed' && job.end_date" class="job-information-card--content-group">
                            <h5 class="job-information-card--content-group-label">Ended Date</h5>
                            <div class="job-information-card--content-group-input">
                                <input type="text" class="form-control w-25 mr-2" v-model="end_day" disabled>
                                <input type="text" class="form-control w-50" v-model="end_month" disabled>
                                <input type="text" class="form-control w-25 ml-2" v-model="end_year" disabled>
                            </div>
                        </div>
                        <div v-if="can_crud_jobs" class="job-information-card--content-group">
                            <button class="btn btn-negative w-100" v-if="job.status !== 'closed'" v-on:click="deleteJob()">Complete Project</button>
                            <button class="btn btn-secondary w-100" v-if="job.status === 'closed'" v-on:click="restoreJob()">Reactivate Project</button>
                        </div>
                    </div>
				</div>
			</div>

			<div class="order-0 order-lg-1 col-lg-5 offset-xl-2 mb-4 mb-md-0" v-if="job.status === 'ready' || job.status === 'opened'">
                <!-- HIDE FROM UI -->
                <!-- <div class="job-information-card">
                    <div class="job-information-card--header">
                        <h5 class="job-information-card--header-title">Reporting</h5>
                    </div>
                    <div class="job-information-card--content">
                        <div class="flex-table">
                            <div class="flex-table--row">
                                <div class="flex-table--cell flex-table--cell-grow-always">
                                    <div>
                                        <h1 class="text-primary">{{submitted_late}}%</h1>
                                        <h6 class="text-secondary">Submitted Late</h6>
                                    </div>
                                </div>
                            </div>

                            <div class="flex-table--row">
                                <div class="flex-table--cell flex-table--cell-grow-always">
                                    <div>
                                        <h1 class="text-primary">{{unresolved}}</h1>
                                        <h6 class="text-secondary">Currently unresolved</h6>
                                    </div>
                                </div>
                            </div>

                            <div class="flex-table--row">
                                <div class="flex-table--cell flex-table--cell-grow-always">
                                    <div>
                                        <h1 class="text-primary">{{submitted_unresolved}}%</h1>
                                        <h6 class="text-secondary">Submitted unresolved</h6>
                                    </div>
                                </div>
                            </div>

                            <div class="flex-table--row">
                                <div class="flex-table--cell flex-table--cell-grow-always">
                                    <div>
                                        <h1 class="text-primary">{{avg_time}}</h1>
                                        <h6 class="text-secondary">Avg time to resolve</h6>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div> -->
				<week-work-days
					style="max-width: 100%"
					v-model="work_week"
					:save_url="save_week_url"
                    :can_crud_jobs="can_crud_jobs"
				></week-work-days>
				<holiday-breaks
					style="max-width: 100%"
					v-model="holiday_breaks"
					:create_url="create_break_url"
					:update_url="update_break_url"
					:destroy_url="destroy_break_url"
				></holiday-breaks>
			</div>
		</div>
	</div>
</template>

<style scoped>
.job-information-card--header-title {
    flex: 0 0 50%;
}
</style>

<script>
	import FileListAndUpload from "../general_components/FileListAndUpload";
    import JobFileUploadButton from "../jobs/JobFileUploadButton";
	import WeekWorkDays from "../settings/WeekWorkDays";
	import HolidayBreaks from "../settings/HolidayBreaks";
    import Loader from "../general_components/Loader.vue";

	export default {
		name: "JobInformationPage",
		components: {
            FileListAndUpload,
            HolidayBreaks,
            JobFileUploadButton,
            Loader,
            WeekWorkDays,
        },
		props: [
			'job',
            'initial_briefing_documents',
			'job_documents',
            'rams_documents',

            'end_job_url',
            'restore_job_url',
            'reporting',

            'can_crud_jobs',
            'has_full_job_access',
            'ssow_url',

            'upload_initial_briefing_url',
            'delete_initial_briefing_url',

            'upload_job_document_url',
            'delete_job_document_url',

            'upload_rams_document_url',
			'delete_rams_document_url',

			'save_week_url',
			'create_break_url',
			'update_break_url',
			'destroy_break_url',

            'update_job_url'
		],

		data(){
			return {
				job_edit: null,
                saving: false,
                errors: [],
                initial_briefing_documents_edit: [],
                job_documents_edit: [],
                rams_documents_edit: [],

				work_week: null,
				holiday_breaks: [],

                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],

				day_selected: null,
				month_selected: null,
				year_selected: null,

                end_day: null,
                end_month: null,
                end_year: null
			}
		},

		beforeMount() {
			this.job_edit = this.job;
            this.initial_briefing_documents_edit = this.initial_briefing_documents;
			this.job_documents_edit = this.job_documents;
            this.rams_documents_edit = this.rams_documents;

			this.work_week = this.job.work_week;
			this.holiday_breaks = this.job.holiday_breaks;

			let _date = new Date(Date.parse(this.job.start_date));
			this.day_selected = _date.getDate();
			this.month_selected = this.months[_date.getMonth()];
			this.year_selected = _date.getFullYear();

            if (this.job.end_date) {
                let _end_date = new Date(Date.parse(this.job?.end_date));
                this.end_day = _end_date.getDate();
                this.end_month = this.months[_end_date.getMonth()];
                this.end_year = _end_date.getFullYear();
            }
		},

        methods: {
            addToInitialBriefingDocument(document){
                Vue.set(this.initial_briefing_documents_edit, this.initial_briefing_documents_edit.length, document);
            },
            addToJobDocuments(document){
                Vue.set(this.job_documents_edit, this.job_documents_edit.length, document);
            },
            addToRamsDocuments(document){
                Vue.set(this.rams_documents_edit, this.rams_documents_edit.length, document);
            },
            processOption(list, option){
                for (let i=0; i < list.length; i++){
                    if (list[i].id === option.item.id){
                        list.splice(i);
                        return;
                    }
                }
            },
			deleteJob(){
				if (!confirm('Are you sure you want to complete this project? By clicking OK, the project will move to Inactive and not be accessible via the app. This can be undone, but may cause issues with repeat forms.')) return;

				let _this = this;

				axios.delete(_this.end_job_url)
                    .then(function (){
                    	window.location.reload();
                    })
                    .catch(function (){
                        Vue.$toast.open({
                            message: 'Could not end job',
                            type: 'error'
                        });
                    })
            },
            restoreJob(){
                if (!confirm('Are you sure you want to make this project active again? Doing so may cause issues with repeat forms.')) return;

                axios.patch(this.restore_job_url)
                    .then(function (){
                        window.location.reload();
                    })
                    .catch(function (){
                        Vue.$toast.open({
                            message: 'Could not reopen job',
                            type: 'error'
                        });
                    })
            },
            editJobDate() {
                if (this.saving) return;

                this.saving = true;

                const date = this.formatDate(`${this.day_selected} ${this.month_selected} ${this.year_selected}`)

                this.errors = []
                axios.patch(this.update_job_url, {
                    name: this.job_edit.name,
                    project_code: this.job_edit.project_code,
                    start_date: date
                })
                .then(() => {
                        this.saving = false
                        Vue.$toast.open({
                                message: "Project details updated",
                                type: 'success'
                            });
                })
                .catch((error) => {
                    this.saving = false
                    if(error.response.data.errors !== undefined){
                        Object.values(error.response.data.errors).forEach((err, i) => {
                            this.errors.push(`<li>${err[0]}</li>`);
                        });
                    }
                    if (this.errors.length >= 2) {
                        Vue.$toast.open({
                            message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    } else if (this.errors.length === 1) {
                        Vue.$toast.open({
                            message: `There was an error: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    }
                })
            },
            formatDate(date) {
                let parsed = Date.parse(date)
                let d = new Date(parsed)
                let month = (d.getMonth() + 1).toString()
                let day = d.getDate().toString()
                let year = d.getFullYear()

                if (month.length < 2) {
                    month = '0' + month
                }

                if (day.length < 2) {
                    day = '0' + day
                }

                return [year, month, day].join('-')
            }
        },

        computed:{
		    submitted_late(){
                return this.reporting.submitted
                    ? (this.reporting.submitted_late / this.reporting.submitted * 100).toFixed(0)
                    : 0;
            },
            submitted_unresolved(){
                return this.reporting.submitted
                    ? ((this.reporting.unresolved + this.reporting.resolved) / this.reporting.submitted * 100).toFixed(0)
                    : 0;
            },
            unresolved(){
		        return this.reporting.unresolved;
            },
            avg_time(){
                return this.reporting.avg_time;
            },
        }
	}
</script>
